import './menu.css';  

function Menu() {
  return (
      <div className='menu'>
        <div className='menu-title'>Ground Operator Menu</div>
        <a href="./#/dropzone-edit" target="_blank">DropZone View</a>
        <br/>
        <a href="./#/ground-op-flights-view" target="_blank">Ground Operator Flights View</a>
      </div>
  )
}

export default Menu;